import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useValidationErrorHandle } from "../functions/validationErrorHandle";
import { format, parse, isValid  } from 'date-fns';   // or dayjs, luxon, moment…
import CustomInput from "./CustomInput";
import { toast } from "react-toastify";

export const ReactDatePicker = (props) => {
  const {isDefaultSelected = true} = props;
  const validationErrorHandle = useValidationErrorHandle()
    const [startDate, setStartDate] = useState(isDefaultSelected ? new Date() : null);
    const [inputValue, setInputValue] = useState(
      isDefaultSelected ? format(new Date(), "MM/dd/yyyy") : ""
    );
    const [customError, setCustomError] = useState('')

    const safeParseToDate = (value: any) => {
      if (!value) return null;
      if (value instanceof Date && !isNaN(value.getTime())) {
        const copy = new Date(value);
        copy.setHours(0, 0, 0, 0);
        return copy;
      }

      if (typeof value === "string") {
        const patterns = ["yyyy-MM-dd", "yyyy/MM/dd", "MM/dd/yyyy"];
        for (const pattern of patterns) {
          const parsed = parse(value, pattern, new Date());
          if (isValid(parsed)) {
            parsed.setHours(0, 0, 0, 0);
            return parsed;
          }
        }
        const parsedNative = new Date(value);
        if (!isNaN(parsedNative.getTime())) {
          parsedNative.setHours(0, 0, 0, 0);
          return parsedNative;
        }
      }
      return null;
    };

    const formatPayloadDate = (d: Date) => {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz === 'Asia/Calcutta') {
        return format(d, 'yyyy-MM-dd');
      }
      return format(d, 'yyyy/MM/dd');
    };

    useEffect(() => {
      if (props?.selected) {
        const parsed = safeParseToDate(props.selected);
        if (parsed) {
          setStartDate(parsed);
          setInputValue(format(parsed, "MM/dd/yyyy"));
        }
      } else if (!props?.selected && !isDefaultSelected) {
        setStartDate(null);
        setInputValue("");
      }
    }, [props.selected]);
    const handleChange = (d) => {

      
      if(props?.minDate){
        const minDateOnly = safeParseToDate(props.minDate)?.getTime();
    const selectedDateOnly = safeParseToDate(d)?.getTime();
        if(minDateOnly>selectedDateOnly){
          toast.error('Plase enter valid date')
          return
        }
      }
      if(props?.maxDate){
                const maxDateOnly = safeParseToDate(props.maxDate)?.getTime();
          const selectedDateOnly = safeParseToDate(d)?.getTime();
       
          if(selectedDateOnly>maxDateOnly){

                toast.error('Plase enter valid date')
          return
          }
      }
      if(!d){
        return

      }
      if (!d || isNaN(d.getTime())) {
    return;
  }

const normalized = safeParseToDate(d);
if (!normalized) {
  return;
}
setStartDate(normalized);

const payloadDate = formatPayloadDate(normalized);
setInputValue(format(normalized, "MM/dd/yyyy"));


  props?.onChange(payloadDate); // send a pure date string



  };


const handleRawChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  setCustomError('');
  const raw = e?.target?.value || '';
  const digits = raw.replace(/\D/g, '');
  const inputType = (e as any)?.nativeEvent?.inputType;
  const isDelete = inputType === 'deleteContentBackward';

  if (!digits) {
    setInputValue('');
    setStartDate(null);
    return;
  }

  // Single-digit month handling: allow 1/0 to wait for second digit; pad others immediately.
  if (digits.length === 1) {
    const first = digits[0];
    if (isDelete) {
      setInputValue(first);
      setStartDate(null);
      return;
    }
    if (!(first === '0' || first === '1')) {
      const monthPadded = first.padStart(2, '0');
      const formatted = `${monthPadded}/`;
      setInputValue(formatted);
      e.target.value = formatted;
    } else {
      setInputValue(first);
    }
    return;
  }

  // Parse sequentially so we can decide whether to auto-pad day when first digit > 3.
  let idx = 0;
  const monthDigits = digits.slice(idx, Math.min(idx + 2, digits.length));
  idx += monthDigits.length;

  let dayDigits = '';
  if (idx < digits.length) {
    const firstDay = digits[idx];
    idx += 1;
    if (Number(firstDay) > 3) {
      dayDigits = `0${firstDay}`;
    } else {
      dayDigits = firstDay;
      if (idx < digits.length) {
        dayDigits += digits[idx];
        idx += 1;
      }
    }
  }

  const yearDigits = digits.slice(idx, Math.min(idx + 4, digits.length));

  let formatted = `${monthDigits}`;
  if (monthDigits.length === 2 && (!isDelete || digits.length > 2)) {
    formatted += '/';
  }
  if (dayDigits.length) {
    formatted += dayDigits;
    if (dayDigits.length === 2 && (!isDelete || yearDigits.length > 0)) {
      formatted += '/';
    }
  }
  if (yearDigits.length) {
    formatted += yearDigits;
  }

  setInputValue(formatted);
  e.target.value = formatted;

  if (yearDigits.length === 4) {
    if (!(monthDigits.length === 2 && dayDigits.length === 2)) {
      return;
    }
    const monthNumber = Number(monthDigits);
    const dayNumber = Number(dayDigits);
    const yearNumber = Number(yearDigits);
    const parsedDate = new Date(yearNumber, monthNumber - 1, dayNumber);

    const isSameDay = parsedDate.getFullYear() === yearNumber &&
      parsedDate.getMonth() === monthNumber - 1 &&
      parsedDate.getDate() === dayNumber;

    if (isValid(parsedDate) && isSameDay) {
      applyParsedDate(parsedDate);
    } else {
      setCustomError('INPUT.VALIDATION.ADVANCE.JOB.DATE');
    }
  }
};


const applyParsedDate = (parsedDate: Date) => {
  if(props?.minDate){
    const minDate = safeParseToDate(props?.minDate)?.getTime();
    const parsedTime = safeParseToDate(parsedDate)?.getTime();
        if(minDate>parsedTime){
          toast.error('Plase enter valid date')
          return
        }
        
      }
          if(props?.maxDate){
                const maxDateOnly = safeParseToDate(props?.maxDate)?.getTime();
          const selectedDateOnly = safeParseToDate(parsedDate)?.getTime();
         
          if(selectedDateOnly>maxDateOnly){

                toast.error('Plase enter valid date')
          return
          }
      }
  parsedDate.setHours(0, 0, 0, 0);
  setStartDate(parsedDate);
  setInputValue(format(parsedDate, "MM/dd/yyyy"));

  const backendFormat = formatPayloadDate(parsedDate);

  props?.onChange(backendFormat);
};

    return (
        <div className={props.InputDivClass}>
        {props.label ? (
          <label className={` ${props.labelClass} text-normal `}>
            {props.label}
          </label>
        ) : (
          ''
        )
        }
        <DatePicker 
        portalId="root"
      placeholderText="mm / dd / yyyy"
name={props.name} className={`${props.inputClass} block w-full  px-4 py-2 text-gray-700 placeholder-gray-500 bg-white border border-gray-border rounded-2xl
                        focus:border-sky-200 focus:ring-sky-200 focus:outline-none focus:ring focus:ring-opacity-40`} 
                        selected={startDate}
                        value={inputValue}
                        dateFormat="MM/dd/yyyy"
                        onChangeRaw={handleRawChange}   
                          {...(props.open === false ? { open: false } : {})}
  
                        onChange={(date, event)=> {
                          
                          if(event?._reactName==='onClick'){
                          handleChange(date)
                        }
                        }
                        }              
                        minDate={props?.minDate ? safeParseToDate(props.minDate) : null}
                         maxDate={props?.maxDate ? safeParseToDate(props.maxDate) : null}

customInput={
       <CustomInput 

></CustomInput>
      }

                         />
         {props.error || customError ? (
            <p className='mt-1 text-red-400 md:text-sm sm:text-[.65rem]'>{validationErrorHandle(props.error || customError)}</p>
          ) : (
            ''
          )}
        </div>
       
      );
    
};
ReactDatePicker.defaultProps = {
    InputDivClass:'mt-10',
    labelClass: 'mt-2 text-gray-700 text-sm',
  }
